import React from "react";
import {
  DataGrid,
  Editing,
  Column,
  Paging,
  Pager,
  Lookup,
} from "devextreme-react/data-grid";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";
import uiInfo from "../ui-info";
import api from "../api-axios";
import UserInfo from "../UserInfo";
import {
  criarStatusProtocoloDs,
  criarTipoProtocoloDs,
  criarSetorAtendimentoProtocoloDs,
} from "..//DataSources";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import notify from "devextreme/ui/notify";

export default class ProtocolosBox extends React.Component {
  constructor() {
    super();

    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    this._grid = React.createRef();
    this.state = { protocolos: [], popupStatus: false, filtro: {} };
    this.statusProtocoloDs = criarStatusProtocoloDs();
    this.tipoProtocoloDs = criarTipoProtocoloDs();
    this.setorProtocoloDs = criarSetorAtendimentoProtocoloDs();
    this.novoStatusOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: this.statusProtocoloDs,
      placeholder: "Selecione...",
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.statusOptions = {
      editorType: "dxSelectBox",
      dataSource: this.statusProtocoloDs,
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.tipoProtocoloOptions = {
      editorType: "dxSelectBox",
      dataSource: this.tipoProtocoloDs,
      valueExpr: "id",
      displayExpr: "nome",
    };

    this.setorProtocoloOptions = {
      editorType: "dxSelectBox",
      dataSource: this.setorProtocoloDs,
      valueExpr: "id",
      displayExpr: "nome",
    };
  }

  showPopupStatus(e) {
    console.log("show popup", e);
    this.setState({ popupStatus: true, protocoloId: e.row.data.id });
  }

  async confirmarNovoStatus() {
    alert("ok");
    console.log("response a");
    console.log(this.state);
    const response = await api.post(
      `protocolos/mudar_status/${this.state.protocoloId}/${this.state.novoStatusId}`
    );

    if (response.status === 200) {
      notify("Dados alterados", "success");
    } else {
      notify("Erro!", "error");
    }
    this.setState({ popupStatus: false });

    const fetchProtocolos = async () => {
      console.log("response a");
      const response = await api.get(
        `protocolos/buscar_protocolos/prefeitura/${UserInfo.getPrefeitura()}`
      );
      console.log("response", response);
      if (response.status === 200 && response.data) {
        this.setState({ protocolos: response.data.data });
      }
    };

    fetchProtocolos();
  }

  componentDidMount() {
    try {
      const fetchProtocolos = async () => {
        const response = await api.get(
          `protocolos/buscar_protocolos/prefeitura/${UserInfo.getPrefeitura()}`
        );
        if (response.status === 200 && response.data) {
          this.setState({ ...this.state, protocolos: response.data.data });
        }
      };

      fetchProtocolos();
    } catch (err) {
      console.log(err);
    }
  }

  filtrar(e) {
    let filtro = [];
    let estado = this.state.filtro;

    if (
      estado.dataInicial !== null &&
      estado.dataInicial !== undefined &&
      estado.dataInicial !== ""
    ) {
      filtro.push(["data", ">=", estado.dataInicial]);
    }
    if (
      estado.dataFinal !== null &&
      estado.dataFinal !== undefined &&
      estado.dataFinal !== ""
    ) {
      filtro.push(["data", "<=", estado.dataFinal]);
    }

    if (estado.sequencial != undefined && estado.sequencial !== -1) {
      filtro.push(["sequencial", "=", estado.sequencial]);
    }

    if (estado.cv != undefined && estado.cv !== -1) {
      filtro.push(["cv", "=", estado.cv]);
    }

    if (estado.status != undefined && estado.status !== -1) {
      filtro.push(["status", "=", estado.status]);
    }

    if (estado.status != undefined && estado.status !== -1) {
      filtro.push(["status.descricao", "=", estado.status]);
    }

    if (estado.tipoProtocolo != undefined && estado.tipoProtocolo !== -1) {
      filtro.push(["tipoProtocolo.nome", "contains", estado.tipoProtocolo]);
    }

    if (estado.solicitante != undefined && estado.solicitante !== -1) {
      filtro.push(["nomeSolicitante", "contains", estado.solicitante]);
    }

    if (estado.documento != undefined && estado.documento !== -1) {
      filtro.push(["documentoSolicitante", "=", estado.documento]);
    }

    if (estado.solicitacao != undefined && estado.solicitacao !== -1) {
      filtro.push(["solicitacoesPrefeitura", "contains", estado.solicitacao]);
    }

    this._grid.instance.filter(filtro.length > 0 ? filtro : null);
  }

  limparFiltro(e) {
    this.setState({ filtro: {} });
    this.filtrar();
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <form onSubmit={this.filtrar}>
          <Form
            id="frmPesquisa"
            formData={this.state.filtro}
            colCount={8}
            labelLocation={"top"}
          >
            <SimpleItem colpan={1} dataField="sequencial">
              <Label text="Protocolo" />
            </SimpleItem>
            <SimpleItem colpan={1} dataField="cv">
              <Label text="CV" />
            </SimpleItem>
            <SimpleItem
              colSpan={2}
              dataField="dataInicial"
              editorType="dxDateBox"
              editorOptions={{
                displayFormat: "dd/MM/yyyy",
                width: "100%",
                useMaskBehavior: true,
              }}
            >
              <Label text="Data Inicial" />
            </SimpleItem>
            <SimpleItem
              colSpan={2}
              dataField="dataFinal"
              editorType="dxDateBox"
              editorOptions={{
                displayFormat: "dd/MM/yyyy",
                width: "100%",
                useMaskBehavior: true,
              }}
            >
              <Label text="Data Final" />
            </SimpleItem>
            <SimpleItem
              colSpan={2}
              dataField="status"
              editorType={"dxSelectBox"}
              editorOptions={this.statusOptions}
            >
              <Label text="Status" />
            </SimpleItem>
            <SimpleItem
              colSpan={2}
              dataField="tipoProtocolo"
              editorType={"dxSelectBox"}
              editorOptions={this.tipoProtocoloOptions}
            >
              <Label text="Tipo" />
            </SimpleItem>
            <SimpleItem
              colSpan={2}
              dataField="setorProtocolo"
              editorType={"dxSelectBox"}
              editorOptions={this.setorProtocoloOptions}
            >
              <Label text="Setor" />
            </SimpleItem>
            <SimpleItem colSpan={2} dataField="solicitante" />
            <SimpleItem colSpan={2} dataField="documento" />
            <SimpleItem
              colSpan={8}
              dataField="solicitacao"
              editorType={"dxTextArea"}
              editorOptions={{ height: "100px" }}
            >
              <Label text="Solicitação" />
            </SimpleItem>
          </Form>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Filtrar"
                type="success"
                onClick={this.filtrar}
              />
            </div>
            <div style={{ display: "inline-block", marginLeft: "10px" }}>
              <Button text="Limpar Filtro" onClick={this.limparFiltro} />
            </div>
          </div>
        </form>
        <br />
        <br />
        <DataGrid
          ref={(e) => (this._grid = e)}
          dataSource={this.state.protocolos}
          showBorders={true}
          rowAlternationEnabled={true}
          remoteOperations={true}
          wordWrapEnabled={true}
          columnAutoWidth={true}
          focusedRowEnabled={true}
          keyExpr={"id"}
        >
          <Editing
            allowAdding={false}
            allowUpdating={false}
            allowDeleting={false}
          />
          <Column
            type="buttons"
            fixed={true}
            fixedPosition={"left"}
            buttons={[
              {
                text: "Mudar status",
                icon: "export",
                onClick: (e) => this.showPopupStatus(e),
              },
              // {
              //   text: "Assumir",
              //   icon: "card",
              //   onClick: () => alert(),
              // },
            ]}
          />
          <Column dataField={"atencao"} caption={"Atenção!"} width={100} />
          <Column
            dataField={"sequencial"}
            caption={"Protocolo"}
            alignment="center"
            width={140}
          />
          <Column dataField={"data"} caption={"Data"} dataType="date" />
          <Column
            dataField={"cv"}
            caption={"CV"}
            alignment="center"
            width={140}
          />
          <Column
            dataField={"data"}
            caption={"Data"}
            dataType="date"
            width={150}
          />
          <Column dataField={"status.descricao"} caption={"Status"}>
            {/* <Lookup
              dataSource={this.statusProtocoloDs}
              valueExpr={"id"}
              displayExpr={"descricao"}
            /> */}
          </Column>
          <Column dataField={"status.situacaoStr"} caption={"Situação"} />
          <Column dataField={"tipoProtocolo.nome"} caption={"Tipo"}>
            {/* <Lookup
              dataSource={this.naturezasDataSource}
              valueExpr={"id"}
              displayExpr={"descricao"}
            /> */}
          </Column>
          <Column dataField={"tipoProtocolo.setor.nome"} caption={"Setor"}>
            {/* <Lookup
              dataSource={this.naturezasDataSource}
              valueExpr={"id"}
              displayExpr={"descricao"}
            /> */}
          </Column>
          <Column dataField={"nomeSolicitante"} caption="Solicitante" />
          <Column dataField={"documentoSolicitante"} caption="Documento" />
          <Column dataField={"solicitacoesPrefeitura"} caption="Solicitação" />

          <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
          <Pager
            showPageSizeSelector={true}
            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
          />
        </DataGrid>
        <Popup
          visible={this.state.popupStatus}
          onHiding={() => this.setState({ popupStatus: false })}
          dragEnabled={false}
          closeOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          width={450}
          height={255}
          title="Mudar Status"
        >
          <Form formData={this.state} colCount={1} labelLocation="top">
            <SimpleItem
              dataField={"novoStatusId"}
              editorType={"dxSelectBox"}
              editorOptions={this.novoStatusOptions}
            >
              <Label text="Novo Status" />
            </SimpleItem>
          </Form>

          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Cancelar DAM",
              type: "success",
              width: 150,
              onClick: () => {
                this.confirmarNovoStatus();
              },
            }}
          />
        </Popup>
      </div>
    );
  }
}
